function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "44",
  height: "50",
  viewBox: "0 0 44 50",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M12.397 17.708c-.038-.287-.174-.347-.32-.347-.145 0-.282.06-.32.347-.294 2.235-1.99 5.495-4.716 8.02C5.263 27.377 0 31.497 0 38.068 0 44.7 5.648 50 12.077 50c6.428 0 12.078-5.3 12.078-11.933 0-6.57-5.264-10.691-7.042-12.338-2.726-2.526-4.422-5.786-4.716-8.021zM31.4 15.169a3.244 3.244 0 01-3.242-3.245 3.244 3.244 0 113.243 3.245zM31.403 0c-6.429 0-12.078 5.3-12.078 11.933 0 6.57 5.263 10.691 7.04 12.338 2.727 2.526 4.423 5.785 4.718 8.021.037.287.173.347.319.347.146 0 .282-.06.32-.347.294-2.236 1.99-5.495 4.716-8.02 1.778-1.648 7.041-5.769 7.041-12.339C43.478 5.299 37.83 0 31.402 0z"
}))));